import React from 'react';
import { Link } from 'react-router-dom';
import { menuItems } from '../../constants/menuItems';
import { MenuFoldIcon } from '../Icons/Icons';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import './Sidebar.css';

const Sidebar = ({ collapsed, onToggle, currentPath }) => {
  const { user } = useAuth();
  const isAdmin = user?.isAdmin === 1;

  const getActiveMenuId = (path) => {
    const item = menuItems.find(item => item.path === path);
    return item ? item.id : 'dashboard';
  };

  const activeMenuId = getActiveMenuId(currentPath);

  const visibleItems = menuItems.filter(item => !item.adminOnly || isAdmin);

  return (
    <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <nav className="menu">
        {visibleItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`menu-item ${activeMenuId === item.id ? 'active' : ''}`}
            >
              <span className="menu-icon">
                <IconComponent size={18} />
              </span>
              <span className="menu-text">{item.text}</span>
            </Link>
          );
        })}
      </nav>
      <div className="sidebar-trigger" onClick={onToggle}>
        {collapsed ? <ChevronRight size={16} /> : <ChevronLeft size={16} />}
      </div>
    </aside>
  );
};

export default Sidebar;
